import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cce3670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap flex-column justify-content-between" }
const _hoisted_2 = ["for", "title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-content-end flex-column" }
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex", [_ctx.labelWrapperClass]])
    }, [
      _createElementVNode("label", {
        class: _normalizeClass([_ctx.labelClass]),
        for: _ctx.name,
        title: _ctx.label
      }, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({ required: _ctx.isRequired }),
              title: _ctx.$t('validations.required')
            }, "*", 10, _hoisted_3))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2),
      (_ctx.info)
        ? (_openBlock(), _createBlock(_component_PopoverIcon, {
            key: 0,
            class: "d-inline-flex flex-0 ml-0"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", { innerHTML: _ctx.info }, null, 8, _hoisted_5)
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", { field: _ctx.field }, undefined, true)
    ]),
    _withDirectives(_createElementVNode("small", {
      id: `${_ctx.name}-help`,
      class: "p-error"
    }, _toDisplayString(_ctx.field?.errorMessage?.value), 9, _hoisted_7), [
      [_vShow, _ctx.shouldShowError]
    ])
  ]))
}